<template>
    <div id='mysched'>
        <h2 class="text-center visible-print">My Schedule</h2>
        <full-calendar
            :events='fullcalendarEventSource'
            :config='fullcalendarConfig'
            :editable='false'
            :selectable='false'
            default-view='month'
        ></full-calendar>
    </div>
</template>

<script>
import {FullCalendar} from 'vue-full-calendar';
export default {
    name: 'mysched',
    components: {
        FullCalendar
    },
    data() {
        return {
            fullcalendarEventSource: {
                url: 'api/cal.cfc',
                cache: true,
                startParam: 'startdate',
                endParam: 'enddate',
                data: {
                    method: 'getEventsByUserToken',
                    fields: 'id,title,date,starttime,endtime'
                },
                headers: {
                    Authorization: `Bearer ${localStorage[this.$store.getters.appToken] || ''}`,
                    'Content-Type': 'application/json'
                },
                error: this.handleLoadError
            },
            fullcalendarConfig: {
                scrollTime: '08:00:00',
                timeFormat: 'h(:mm)t',
                viewRender: this.handleFullCalendarViewRender
            }
        };
    },
    methods: {
        handleLoadError(error) {
            if ((/signature verification failed/i).test(error.statusText)) {
                // Only redirect if the router is not already at the login route
                if (this.$route.path != '/login') this.$router.push('/login?destination=' + this.$route.path);
            } else {
                // eslint-disable-next-line no-alert
                alert(error.statusText);
            }
        }
    }
};
</script>

<style src="../css/form-global.css" scoped></style>
<style src="../css/loading-spinner.css" scoped></style>
<style src="../../node_modules/fullcalendar/dist/fullcalendar.min.css"></style>
<style>
.fc-event {
    color: white !important;
}
@media print {
    .fc {
        max-width: 100% !important;
    }
    .fc-event {
        background: #fff !important;
        color: #000 !important;
        page-break-inside: avoid;
    }
    .fc-event .fc-resizer {
        display: none;
    }
    .fc th,
    .fc td,
    .fc hr,
    .fc thead,
    .fc tbody,
    .fc-row {
        border-color: #ccc !important;
        background: #fff !important;
    }
    .fc-bg,
    .fc-bgevent-skeleton,
    .fc-highlight-skeleton,
    .fc-helper-skeleton,
    .fc-bgevent-container,
    .fc-business-container,
    .fc-highlight-container,
    .fc-helper-container {
        display: none;
    }
    .fc tbody .fc-row {
        height: auto !important;
        min-height: 0 !important;
    }
    .fc tbody .fc-row .fc-content-skeleton {
        position: static;
        padding-bottom: 0 !important;
    }
    .fc tbody .fc-row .fc-content-skeleton tbody tr:last-child td {
        padding-bottom: 1em;
    }
    .fc tbody .fc-row .fc-content-skeleton table {
        height: 1em;
    }
    .fc-more-cell,
    .fc-more {
        display: none !important;
    }
    .fc tr.fc-limited {
        display: table-row !important;
    }
    .fc td.fc-limited {
        display: table-cell !important;
    }
    .fc-popover {
        display: none;
    }
    .fc-time-grid {
        min-height: 0 !important;
    }
    .fc-agenda-view .fc-axis {
        display: none;
    }
    .fc-slats,
    .fc-time-grid hr {
        display: none !important;
    }
    .fc-time-grid .fc-content-skeleton {
        position: static;
    }
    .fc-time-grid .fc-content-skeleton table {
        height: 4em;
    }
    .fc-time-grid .fc-event-container {
        margin: 0 !important;
    }
    .fc-time-grid .fc-event {
        position: static !important;
        margin: 3px 2px !important;
    }
    .fc-time-grid .fc-event.fc-not-end {
        border-bottom-width: 1px !important;
    }
    .fc-time-grid .fc-event.fc-not-end:after {
        content: '...';
    }
    .fc-time-grid .fc-event.fc-not-start {
        border-top-width: 1px !important;
    }
    .fc-time-grid .fc-event.fc-not-start:before {
        content: '...';
    }
    .fc-time-grid .fc-event .fc-time {
        white-space: normal !important;
    }
    .fc-time-grid .fc-event .fc-time span {
        display: none;
    }
    .fc-time-grid .fc-event .fc-time:after {
        content: attr(data-full);
    }
    .fc-scroller,
    .fc-day-grid-container,
    .fc-time-grid-container {
        overflow: visible !important;
        height: auto !important;
    }
    .fc-row {
        border: 0 !important;
        margin: 0 !important;
    }
    .fc-button-group,
    .fc button {
        display: none;
    }
}
</style>
<style scoped>
table tbody tr {
    cursor: pointer;
}
</style>